import * as React from "react"
import {Connection} from '../../../api/graphql'
import {FooterMenu, FooterMenuLanguage} from './footermenu'
import { Route, RoutesOutput, Area } from "../../../types/types";

export type TopFooterRoutes = {
  boolean_gites: Route
  boolean_bed_and_breakfasts: Route
  boolean_sale_adverts: Route
  themes: Route
  areas: Route
  boolean_gites_swimmingpool: Route
  boolean_gites_sea: Route
  boolean_gites_beach: Route
  boolean_gites_watersports: Route
  lastminutes: Route
  boolean_bed_and_breakfasts_swimmingpool: Route
  boolean_bed_and_breakfasts_skiing: Route
  boolean_sale_adverts_swimmingpool: Route
  boolean_sale_adverts_commerce: Route
  dutch_root: Route
  french_root: Route
  german_root: Route
  english_root: Route
}

type Props = {
  routes: RoutesOutput<TopFooterRoutes>
  areas:Connection<Area>
}

export const TopFooter = (props: Props) => (
  <>
    <div className="footer">
      <div className="grid-container">
        <div className="footer__social">
          <p>{I18n.t("footer.social.intro")}</p>
          <div  className="footer__social-items">
            <a href={I18n.t("footer.social.facebook")}>
              <svg className="facebook" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <rect height="48" rx="24" width="48"/>
                  <path d="m12.1 0h-3.3c-3.03756612 0-5.5 2.46243388-5.5 5.5v3.3h-3.3v4.4h3.3v8.8h4.4v-8.8h3.3l1.1-4.4h-4.4v-3.3c0-.60751322.49248678-1.1 1.1-1.1h3.3z" transform="translate(18 13)"/>
                </g>
              </svg>
            </a>
            <a href={I18n.t("footer.social.instagram")}>
              <svg className="instagram" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" fillRule="evenodd">
                  <rect height="48" rx="24" width="48"/>
                  <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" transform="translate(13 13)">
                    <rect height="22" rx="5" width="22"/>
                    <path d="m15.4 10.307c.2784347 1.8776688-.6786716 3.722229-2.3742108 4.5756412-1.6955393.8534123-3.74723578.5232665-5.08946635-.8189641-1.34223057-1.3422305-1.67237633-3.393927-.81896408-5.08946628.85341226-1.69553925 2.69797248-2.6526455 4.57564123-2.37421082 1.9172744.28430771 3.4226923 1.78972556 3.707 3.707z"/>
                  </g>
                </g>
              </svg>
            </a>
            <a href={I18n.t("footer.social.pinterest")}>
              <svg className="pinterest" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
                <path d="m24 .15167a24 24 0 1 0 24 24 24 24 0 0 0 -24-24zm1.9939 30.38733a4.25443 4.25443 0 0 1 -3.62653-1.84906s-.86169 3.41992-1.04394 4.07971a15.84662 15.84662 0 0 1 -2.67963 4.8584.19775.19775 0 0 1 -.353-.08618 16.65244 16.65244 0 0 1 .04413-5.6402c.285-1.20538 1.9093-8.0888 1.9093-8.0888a5.71163 5.71163 0 0 1 -.47345-2.349c0-2.19953 1.27551-3.842 2.86292-3.842a1.98755 1.98755 0 0 1 2.00171 2.228c0 1.35853-.86432 3.38721-1.31025 5.268a2.2978 2.2978 0 0 0 2.34333 2.85925c2.81146 0 4.70575-3.61248 4.70575-7.89312 0-3.25226-2.19013-5.68793-6.17646-5.68793a7.03053 7.03053 0 0 0 -7.30859 7.10925 4.2788 4.2788 0 0 0 .9801 2.91071.72082.72082 0 0 1 .21387.82745c-.07214.2746-.23462.93182-.30316 1.19135a.51054.51054 0 0 1 -.74335.37115c-2.07281-.84558-3.03943-3.11676-3.03943-5.66974 0-4.21728 3.55646-9.27344 10.60913-9.27344 5.66767 0 9.397 4.10047 9.39649 8.50409-.00003 5.82244-3.23776 10.17211-8.00894 10.17211z" />
              </svg>
            </a>
          </div>
        </div>
        <div className="footer__menus">
          <FooterMenu
            title={I18n.t("footer.links.popular_areas.title")}
            items={props.areas.edges.map(x => {
              return {
                title: I18n.t("footer.links.popular_areas.text", {area: x.node.name}),
                url: x.node.path
              }
            })}
          />
          <FooterMenu
            title={I18n.t("footer.links.bed_and_breakfast.title")}
            items={[
              {
                title: I18n.t("footer.links.bed_and_breakfast.all"),
                url: props.routes.get("boolean_bed_and_breakfasts").url
              },
              {
                title: I18n.t("footer.links.bed_and_breakfast.swimmingpool"),
                url: props.routes.get("boolean_bed_and_breakfasts_swimmingpool").url
              },
              {
                title: I18n.t("footer.links.bed_and_breakfast.ski"),
                url: props.routes.get("boolean_bed_and_breakfasts_skiing").url
              }
            ]}
          />
          <FooterMenu
            title={I18n.t("footer.links.sale.title")}
            items={[
              {
                title: I18n.t("footer.links.sale.all"),
                url: props.routes.get("boolean_sale_adverts").url
              },
              {
                title: I18n.t("footer.links.sale.swimmingpool"),
                url: props.routes.get("boolean_sale_adverts_swimmingpool").url
              },
              {
                title: I18n.t("footer.links.sale.commercial"),
                url: props.routes.get("boolean_sale_adverts_commerce").url
              }
            ]}
          />
          <FooterMenu
            title={I18n.t("footer.links.gites.title")}
            items={[
              {
                title: I18n.t("footer.links.gites.swimmingpool"),
                url: props.routes.get("boolean_gites_swimmingpool").url
              },
              {
                title: I18n.t("footer.links.gites.sea"),
                url: props.routes.get("boolean_gites_sea").url
              },
              {
                title: I18n.t("footer.links.gites.beach"),
                url: props.routes.get("boolean_gites_beach").url
              },
              {
                title: I18n.t("footer.links.gites.aquatics"),
                url: props.routes.get("boolean_gites_watersports").url
              }
            ]}
          />
          <FooterMenuLanguage
            title={I18n.t("footer.links.languages.title")}
            items={[
              { title: I18n.t("languages.labels.dutch", { locale: "nl" }), url: props.routes.get("dutch_root").url },
              { title: I18n.t("languages.labels.english", { locale: "en" }), url: props.routes.get("english_root").url },
              { title: I18n.t("languages.labels.french", { locale: "fr" }), url: props.routes.get("french_root").url },
              { title: I18n.t("languages.labels.german", { locale: "de" }), url: props.routes.get("german_root").url }
            ]}
          />
        </div>
      </div>
    </div>
  </>
);
